export default {
    create : {title : "🤖 Create a new bot", send : "Create"},
    update : {title : "🤖 Update your bot",  send : "Update"}
}